import createVueComponent from '../createVueComponent';

const Tally1 = createVueComponent('Tally1Icon', [
  ['path', { d: 'M4 4v16', key: '6qkkli' }],
]);

export default Tally1;
